import { createFileRoute } from '@tanstack/react-router';
import { AnalyticsHubPage } from '@/pages/chain/analytics/AnalyticsHubPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

function ChainAnalytics() {
	return <AnalyticsHubPage />;
}

export const Route = createFileRoute('/_authenticated/_app/chain/analytics')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['chainHq.readAnalytics', 'chainHq.read'], redirectTo: '/dashboard' }),
	component: ChainAnalytics,
});
